import { Box, Grid, Slider, Typography } from '@mui/material'
import Style from '../../molecules/VenderModal/VendorModal.module.scss'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import Stepper from '../../atoms/Stepper/Stepper'
import { BUSINESS_PROFILE_TOTAL_STEPS } from '../../../util/constants'

const defaultCover =
	'https://static.vecteezy.com/system/resources/previews/021/686/124/large_2x/blue-background-high-resolution-wallpaper-free-free-photo.jpg'
const MIN = 5
const MAX = 20000

function Capacity({ step, setStep, formData, setFormData, onUpdateProfile, saving = false }) {
	const handleChange = (e) => {
		const value = e.target.value
		if (value >= MIN && value <= MAX) {
			setFormData({ ...formData, maxCapacity: value })
		}
	}
	return (
		<>
			<Grid size={{ xs: 12, sm: 6 }}>
				<div className={Style.imageContainer}>
					<img src={defaultCover} alt="signup-img.jpg" />
				</div>
			</Grid>
			<Grid size={{ xs: 12, sm: 6 }} className={Style.formContainer}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'space-between',
						minHeight: '80%',
						height: '100%',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
						className={Style.titleContainer}
					>
						<Typography
							variant="h3"
							gutterBottom
							className={Style.title}
						>
							Capacity
						</Typography>
						<Typography
							color="#7ca6bd"
							variant="h6"
							className={Style.modalSemiTitle}
						>
							Enter your business capacity
						</Typography>
					</Box>
					<Box sx={{ width: '100%' }}>
						<Box className={Style.priceRange}>
							<input
								value={formData.maxCapacity}
								onChange={handleChange}
								style={{
									width: 'fit-content',
									margin: '0 auto',
									textAlign: 'center',
									fontFamily: 'var(--body-font-one)',
									fontWeight: '400',
								}}
							/>
						</Box>
						<Slider
							value={formData.maxCapacity}
							onChange={(e, newValue) =>
								setFormData({
									...formData,
									maxCapacity: newValue,
								})
							}
							max={MAX}
							min={MIN}
							sx={{
								color: '#7ca6bd',
								'& .MuiSlider-track': {
									backgroundColor: '#7ca6bd',
								},
								'& .MuiSlider-thumb': {
									border: '0.1px solid white',
									width: '12px',
									height: '12px',
								},
								'& .MuiSlider-rail': {
									backgroundColor: '#FFFFFF',
									opacity: 1,
								},
							}}
						/>
					</Box>
					<Box
						className={Style.buttonContainer}
						sx={{ justifyContent: 'space-between' }}
					>
						<ButtonCustom
							onClick={() => setStep((step) => step - 1)}
							className="backButton"
						>
							Previous
						</ButtonCustom>
						<ButtonCustom
							disabled={saving}
							onClick={() => { onUpdateProfile(() => setStep((step) => step + 1))}}
						>
							{saving ? 'Saving…' : 'Next'}
						</ButtonCustom>
					</Box>
					<Box>
						<Stepper
							totalSteps={BUSINESS_PROFILE_TOTAL_STEPS}
							subSteps={1}
							activeStep={step}
						/>
					</Box>
				</Box>
			</Grid>
		</>
	)
}

export default Capacity
